<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { getDeviceSettings, getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from 'src/configs/devices';
	import ControlEffects from 'src/components/Controls/Single/ControlEffects.svelte';
	import { ControlsContainer, SidepanelContent } from '@Shelly/shelly-design-system';
	import { get_mode } from 'src/helpers/interface_helpers';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: mode = get_mode(device, status, settings);
	$: effects = devices_config?.[device?.type]?.modes?.[mode]?.effects;
	$: hasEffects = Array.isArray(effects) && effects.length > 0;
</script>

<SidepanelContent>
	{#if hasEffects}
		<ControlsContainer class="mb-m" color="color-0">
			<div slot="first">
				<ControlEffects {device} />
			</div>
		</ControlsContainer>
	{/if}
</SidepanelContent>
